import { type SxProps } from '@mui/material/styles';

export const getStyles = (isAdminMode: boolean) =>
  ({
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 40px',
      height: '65px',
      boxSizing: 'border-box',
      width: '100%',
      borderBottom: '1px solid rgba(98, 111, 136, 0.56)',
      ...(isAdminMode && {
        background: 'linear-gradient(90deg, rgba(79, 70, 229, 0.05) 0%, rgba(99, 102, 241, 0.05) 100%)',
      }),
    },
    left: {
      display: 'flex',
      alignItems: 'center',
      gap: '24px',
    },
    logo: {
      display: 'flex',
      alignItems: 'center',
      mr: 2,
    },
    adminBadge: {
      backgroundColor: '#4f46e5',
      color: '#ffffff',
      fontWeight: 600,
      fontSize: '12px',
      height: '24px',
    },
    switchButton: {
      textTransform: 'none',
      fontSize: '12px',
      fontWeight: 500,
      color: '#4f46e5',
      border: '1px solid #4f46e5',
      borderRadius: '6px',
      padding: '4px 12px',
      height: '28px',
      '&:hover': {
        backgroundColor: 'rgba(79, 70, 229, 0.08)',
      },
    },
    right: {
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
    },
    notificationIcon: {
      color: '#3C4856',
      fontSize: 24,
    },
    userIconButton: {
      padding: 0,
    },
    avatar: {
      width: 32,
      height: 32,
      cursor: 'pointer',
      boxShadow: isAdminMode ? '0px 2px 8px rgba(79, 70, 229, 0.25)' : '0px 2px 8px rgba(55, 125, 255, 0.15)',
      backgroundColor: 'transparent',
      border: isAdminMode ? '2px solid #4f46e5' : '1px solid #6C7680',
      color: isAdminMode ? '#4f46e5' : '#9FACBD',
      fontSize: 12,
      fontStyle: 'normal',
      fontWeight: isAdminMode ? 600 : 400,
    },
  }) satisfies Record<string, SxProps>;
